<div class="form-group" (blur)="onTouched()">
  <label>Partners</label>
  <ep-partner-selector #partnerSelector [isReadOnly]="disabled" [showLoadingPartnerDetails]="false"
    (selectedPartnerIdChange)="selectedPartnerIdChange($event)">
  </ep-partner-selector>

  @if ((partners$ | async); as partners) {
    <div class="mt-1 list-group">
      @if (partners?.length) {
        @for (partner of partners; track partner) {
          <div class="list-group-item" [class.disabled]="disabled">
            @if (!disabled) {
              <a class="badge" (click)="remove(partner.PartnersId)" role="button">&times;</a>
            }
            <p class="list-group-item-text">
              <strong>{{partner.PartnerName}}</strong> ({{partner.PartnerType.Name}})
            </p>
            <p class="list-group-item-text">
              {{partner.MainIdentificationType?.IdentificationType?.Name}}:
              {{partner.MainIdentificationType?.Value}}
            </p>
            <p class="list-group-item-text">
              <em>{{partner.EdiPortalId}}</em>
            </p>
          </div>
        }
      } @else {
        <div class="list-group-item disabled">
          <p class="list-group-item-text">&nbsp;</p>
          <p class="list-group-item-text text-center">
            <em>List is empty</em>
          </p>
          <p class="list-group-item-text">&nbsp;</p>
        </div>
      }
    </div>
  } @else {
    <div class="list-group-item disabled">
      <p class="list-group-item-text">&nbsp;</p>
      <p class="list-group-item-text text-center">
        <em>Loading...</em>
      </p>
      <p class="list-group-item-text">&nbsp;</p>
    </div>
  }


</div>
